import { CommonModule, NgIf, NgOptimizedImage } from '@angular/common';
import { Component, Output, EventEmitter, ViewEncapsulation, ChangeDetectionStrategy, signal, input } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { Capacitor } from '@capacitor/core';
import { IonInput, IonicModule } from '@ionic/angular';
import { AutofillDirective } from 'src/app/shared/directives/autofill.directive';
import { SavePassword } from 'capacitor-ios-autofill-save-password';

type AuthProps = {
    email: string;
    password: string;
};

@Component({
    selector: 'app-auth-form',
    templateUrl: './auth-form.component.html',
    styleUrls: ['./auth-form.component.scss'],
    imports: [ReactiveFormsModule, CommonModule, IonicModule, AutofillDirective, NgOptimizedImage],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthFormComponent {
    isSignIn = signal<boolean>(true);
    authForm = this.fb.group({
        email: ['', [Validators.required, Validators.email]],
        password: [
            '',
            [
                Validators.required
            ],
        ],
    });

    readonly resetOnSubmit = input(false);
    readonly resetOnAuthModeChange = input(false);
    readonly loading = input<boolean>(false);
    @Output() modeChange = new EventEmitter<string>();
    @Output() submit = new EventEmitter<AuthProps>();
    @Output() forgotPassword = new EventEmitter<void>();
    @Output() googleLogin = new EventEmitter<void>();
    @Output() appleLogin = new EventEmitter<void>();
    @Output() microsoftLogin = new EventEmitter<void>();
    constructor(private fb: FormBuilder) {}

    handleChange(e: Event) {
        e.preventDefault();
        this.isSignIn.set(!this.isSignIn());
        this.modeChange.emit(this.isSignIn() ? 'signIn' : 'register');
        if (this.resetOnAuthModeChange()) {
            this.authForm.reset();
        }
    }

    handleForgotPassword() {
        this.forgotPassword.emit();
    }

    handleGoogleLogin() {
        this.googleLogin.emit();
    }

    handleAppleLogin() {
        this.appleLogin.emit();
    }

    handleMicrosoftLogin() {
        this.microsoftLogin.emit();
    }

    async handleSubmit() {
        const email = this.authForm.value['email'];
        const password = this.authForm.value['password'];
        this.submit.emit({ email, password });
        if (this.resetOnSubmit()) {
            this.authForm.reset();
        }
        if (Capacitor.getPlatform() === 'ios') {
            await SavePassword.promptDialog({
                username: email,
                password: password
            });
        }
    }
}
